import { forwardRef, useEffect, useState } from 'react';

import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { useTimer } from 'hooks/timer';
import PropTypes from 'prop-types';

import styles from './SearchInput.module.scss';

export const SearchInput = forwardRef(
  (
    { placeholder, className, value: externalValue, onChange = () => {}, regex, dataTestId },
    ref,
  ) => {
    const [value, setValue] = useState(externalValue ?? '');

    // Sync internal state with external value prop when it changes
    useEffect(() => {
      if (externalValue !== undefined) {
        setValue(externalValue);
      }
    }, [externalValue]);

    const resetTimer = useTimer(1, () => onChange(value));

    const handleChange = e => {
      // Remove special characters, allow only alphanumeric and spaces
      if (regex) {
        const sanitizedValue = e.target.value.replace(regex, '');
        setValue(sanitizedValue);
      } else {
        setValue(e.target.value);
      }
      resetTimer();
    };

    return (
      <div className={cn(styles.root, { [className]: className })}>
        <FeatherIcon className={styles.icon} icon="search" />

        <input
          ref={ref}
          type="text"
          value={value}
          onChange={handleChange}
          className={styles.input}
          placeholder={placeholder}
          data-testid={dataTestId}
        />
      </div>
    );
  },
);

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  dataTestId: PropTypes.string,
};
